/**
 * Bandeiras do seletor de idioma, desenhadas em SVG inline.
 *
 * Substituem o pacote react-world-flags, que embutia as bandeiras de todos os
 * países no bundle (~3,7 MB, mais da metade do main.js) para mostrar só estas
 * duas. Emoji de bandeira não serve: o Windows não desenha, mostra "BR"/"US".
 */
import React from 'react';

interface BandeiraIdiomaProps {
  idioma: 'pt' | 'en';
  altura?: number;
}

const BandeiraIdioma: React.FC<BandeiraIdiomaProps> = ({ idioma, altura = 12 }) => {
  if (idioma === 'pt') {
    return (
      <svg viewBox="0 0 20 14" height={altura} aria-hidden="true" style={{ verticalAlign: 'baseline' }}>
        <rect width="20" height="14" fill="#009C3B" />
        <polygon points="10,1.7 18.3,7 10,12.3 1.7,7" fill="#FFDF00" />
        <circle cx="10" cy="7" r="3.5" fill="#002776" />
      </svg>
    );
  }

  const faixa = 10 / 13;
  return (
    <svg viewBox="0 0 19 10" height={altura} aria-hidden="true" style={{ verticalAlign: 'baseline' }}>
      <rect width="19" height="10" fill="#B22234" />
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <rect key={i} y={(2 * i + 1) * faixa} width="19" height={faixa} fill="#FFFFFF" />
      ))}
      <rect width="7.6" height={7 * faixa} fill="#3C3B6E" />
    </svg>
  );
};

export default BandeiraIdioma;
